<template>
  <div class="counselor-card-meeting-types meeting-type-icons">
    <div
      class="counselor-card-meeting-types__location"
      v-if="(isTherapist || isLawyer) && locationText"
    >
      <span>{{ basedInText }} <strong v-text="locationText" /></span>
      <span v-if="isArchive && distanceText" v-text="distanceText" />
    </div>
    <div
      class="counselor-card-meeting-types__item meeting-type-icons__icon-wrapper"
      v-for="meetingType in sortedMeetingTypes"
      :key="meetingType"
      :class="{
        'counselor-card-meeting-types__item--active':
          filteredMeetingTypes.includes(meetingType),
      }"
    >
      <svg class="meeting-type-icons__icon">
        <use :xlink:href="`#${icons[meetingType]}`" />
      </svg>
    </div>
  </div>
</template>

<script>
import { MEETING_TYPE_KEYS } from 'Constants/meetingTypes';
import { getThemeText } from 'Constants/themeVars';
import { formatDistance } from 'Utils/distance';
import { sprintf } from 'sprintf-js';

export default {

  computed: {

    distanceText() {
      if (!this.counselor.distance) {
        return '';
      }

      const formattedDistance = formatDistance(
        this.counselor.distance,
        this.currentSite || 'SE'
      );

      return sprintf(this.awayFromText, formattedDistance);
    },

    locationText() {
      if (!this.counselor.address) {
        return '';
      }

      const { city, postcode } = this.counselor.address;

      if (!city) {
        return '';
      }

      if (this.currentSite === 'GB' && postcode) {
        return `${city}, ${postcode}`;
      }

      return city;
    },
    meetingTypes() {
      return this.counselor.meeting_types;
    },

    selectedMeetingTypes() {
      return this.meetingTypes.filter((meetingType) =>
        this.filteredMeetingTypes.includes(meetingType)
      );
    },

    sortedMeetingTypes() {
      if (!this.filteredMeetingTypes.length) {
        return this.meetingTypes;
      }

      return [...this.selectedMeetingTypes, ...this.unSelectedMeetingTypes];
    },

    unSelectedMeetingTypes() {
      return this.meetingTypes.filter(
        (meetingType) => !this.filteredMeetingTypes.includes(meetingType)
      );
    },
  },

  data() {
    return {
      awayFromText: getThemeText('counselorGridTexts.awayFrom', '%s away'),
      basedInText: getThemeText('counselorGridTexts.basedIn', 'Based in'),
      currentSite: window.theme_vars.currentSite,
      icons: {
        [MEETING_TYPE_KEYS.IN_PERSON]: 'meeting-location-pin',
        [MEETING_TYPE_KEYS.VIDEO]: 'meeting-video',
        [MEETING_TYPE_KEYS.PHONE]: 'meeting-phone',
      },
    };
  },
  name: 'CounselorCardMeetingTypes',

  props: {
    counselor: {
      required: true,
      type: Object,
    },
    filteredMeetingTypes: {
      required: true,
      type: Array,
    },
    isArchive: {
      default: false,
      type: Boolean,
    },
    isLawyer: {
      default: false,
      type: Boolean,
    },
    isTherapist: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
